var _rect, _path, _rect2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFolder2 = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 139,
    height: 139,
    rx: 69.5,
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.625 52.2005H81.3C90.525 52.2005 95.025 57.1255 95 67.2255V79.4005C95 89.0505 89.05 95.0005 79.375 95.0005H60.6C50.975 95.0005 45 89.0505 45 79.3755V60.6005C45 50.2505 49.6 45.0005 58.675 45.0005H62.625C64.9525 44.9755 67.125 46.0505 68.55 47.8755L70.75 50.8005C71.45 51.6755 72.5 52.2005 73.625 52.2005ZM58.425 78.2255H81.575C82.6 78.2255 83.425 77.3755 83.425 76.3505C83.425 75.3005 82.6 74.4755 81.575 74.4755H58.425C57.375 74.4755 56.55 75.3005 56.55 76.3505C56.55 77.3755 57.375 78.2255 58.425 78.2255Z",
    fill: "#414141"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 139,
    height: 139,
    rx: 69.5,
    stroke: "#E7E7E7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolder2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Folder2.93cc1251.svg";
export { ForwardRef as ReactComponent };